import React from 'react';
import DialogDataComponent from 'Core/components/DialogDataComponent';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Label from 'Core/components/display/Label';
import NumberLabel from 'Core/components/display/NumberLabel';
import {getNumber, getString, isset} from 'Core/helpers/data';
import CustomerGroupImportCustomersList, {reducerStoreKey} from 
		'Pages/apps/default/customerGroups/popups/ItemPopup/tabs/CustomersTab/components/CustomerGroupImportCustomersList'
import {selectors} from 'Core/store/reducers';
import {
	icon_font_close_symbol,
	icon_font_create_symbol,
	icon_font_save_symbol
} from 'Config/app';
import {isMacintosh} from 'Core/helpers/system';
import {BUTTON_STYLE} from 'Core/components/display/Button';

/**
 * Redux 'mapStateToProps' function
 *
 * @param {object} state - Redux entire store state.
 * @return {Object<string, any>} Mapped props that can be used in a component.
 */
const mapStateToProps = state => ({
	totalRows: getNumber(selectors[reducerStoreKey].getCustomersListPagination(state), 'totalRows'),
});

class CustomerGroupPreviewDialog extends DialogDataComponent {
	constructor(props) {
		super(props, {
			data: getString(props, 'customerGroup.id'),
		}, {
			translationPath: 'CustomerGroupPreviewDialog',
			disableLoad: true,
		});
	}

	/** @inheritDoc */
	renderDataActionButtons({
		saveLabel = undefined, saveIcon = undefined, closeLabel = undefined, closeIcon = undefined,
	} = {}, hideClose = false) {
		const {totalRows, showSubmitButton} = this.props;

		let buttons = [];

		// Close/cancel button
		if (isMacintosh() && !hideClose) buttons.push({
			style: BUTTON_STYLE.DEFAULT,
			label: (closeLabel ? closeLabel : this.t('Close', 'general')),
			icon: (isset(closeIcon) && closeLabel !== null ? closeIcon : icon_font_close_symbol),
			onClick: this.close,
		});

		
		if (showSubmitButton) {
			buttons.push({
				style: BUTTON_STYLE.HIGHLIGHT,
				label: (saveLabel ? saveLabel : this.t('Save', 'general')),
				icon: (isset(saveIcon) && saveIcon !== null ? saveIcon : icon_font_save_symbol),
				onClick: this.save,
				autofocus: true,
				disabled: (totalRows === 0)
			});
		}

		// Close/cancel button
		if (!isMacintosh() && !hideClose) buttons.push({
			style: BUTTON_STYLE.DEFAULT,
			label: (closeLabel ? closeLabel : this.t('Close', 'general')),
			icon: (isset(closeIcon) && closeLabel !== null ? closeIcon : icon_font_close_symbol),
			onClick: this.close,
		});

		return this.renderActionButtons(buttons);
	}
	
	render() {
		const {projectId, customerGroup, totalRows} = this.props;
		
		return this.renderDialog(
			this.renderTitle(<><Label content={this.t('title')} /> (<NumberLabel number={totalRows} />)</>),
			(
				<CustomerGroupImportCustomersList
					readOnly={true}
					hideSearch={true}	
					projectId={projectId}
					customerGroupId={getString(customerGroup, 'id')}
					customerGroupName={getString(customerGroup, 'name')}
				/>
			), {
				saveLabel: this.t('add_btn'),
				saveIcon: icon_font_create_symbol,
			}
		);
	}
}

/**
 * Define a component's own props that can be passed to it by parent components
 */
CustomerGroupPreviewDialog.propTypes = {
	projectId: PropTypes.string,
	customerGroup: PropTypes.object,
	showSubmitButton: PropTypes.bool,
};

CustomerGroupPreviewDialog.defaultProps = {
	showSubmitButton: true,
};

export default connect(mapStateToProps, null)(CustomerGroupPreviewDialog);